export default "__VITE_ASSET__DpE$87u___"